// GLOBAL VARIABLE SETUP
// =================================================================================================
// COMPONENTS
import React from 'react';

import '../../styles/subtitle-block.css'

// HELP FUNCTIONS
import '../../utils/canvas-to-blob';
import '../../utils/kawo-tooltip';

import _ from 'underscore';


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class SubtitleBlock extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		this.state = {};
	}


	// =============================================================================================
	componentDidMount() {
		this.setState( prevState => ( this.props.data ) );
	}


	componentWillReceiveProps( nextProps ) {
		this.setState( prevState => ( nextProps.data ) );
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {

		let changedStartTime = this.state.initialStart && this.state.initialStart !== this.state.start,
			changedEndTime = this.state.initialEnd && this.state.initialEnd !== this.state.end;

		return <div className={ 'st-track__block' +
					( this.state.active ? ' st-track__block_active' : '' ) +
					( this.state.current ? ' st-track__block_current' : '' ) }
					data-start={this.state.start}
					data-end={this.state.end}
					data-id={this.state.id}
					style={{left: this.state.leftPos, width: this.state.width}}
					onClick={( e ) => this.setActiveBlock( e )}>

			<div className="st-track__block__handle st-track__block__handle_left" data-target="left-handle" />

			<div className={ 'st-track__block__handle st-track__block__handle_middle' +
				( this.state.dragging && ( changedStartTime || changedEndTime ) ? ' st-track__block__handle_dragging' : '' ) }
				 data-target="middle-handle">
				<p>{this.state.text}</p>
			</div>

			<div className="st-track__block__handle st-track__block__handle_right" data-target="right-handle" />
		</div>
	}


	// =============================================================================================
	setActiveBlock( e ) {

		let changedStartTime = this.state.initialStart && this.state.initialStart !== this.state.start,
			changedEndTime = this.state.initialEnd && this.state.initialEnd !== this.state.end;

		// ONLY SET ACTIVE BLOCK ON PARENT STATE IF WE DIDNT RESIZE OR MOVE THE BLOCK
		if ( !changedStartTime && !changedEndTime ) {

			this.props.setActiveBlock( e );

			// UNSET INITIAL START AND END SO SUBSEQUENT CLICKS WILL PASS THROUGH
			this.setState( prevState => ({
				initialStart: null,
				initialEnd: null
			}) );
		}
	}


	// =============================================================================================
	startDragging( e, dragTarget ) {

		this.start = e.pageX;

		this.setState( prevState => ({
			dragging: true,
			dragTarget: dragTarget,
			initialStart: this.state.start,
			initialEnd: this.state.end
		}) );
	}


	// =============================================================================================
	stopDragging( e ) {

		let $this = this;

		this.setState( prevState => ({
			dragging: false,
			dragTarget: false
		}) );

		// HELPER FUNCTION TO IMMUTABLY UPDATE AN SRT BLOCK
		const srtBlockReducer = ( state, action, value ) => {

			return Object.assign(
				[ ...state ],
				{ [ action.index ]: Object.assign({}, state[ action.index ], value ) }
			);
		};

		// FIND THIS SRT BLOCK
		let srtBlock = _.findIndex( $this.props.editor.state.jsonSrt || [], function( st ) {
			return st.id === $this.state.id;
		});

		let updatedJsonSrt = srtBlockReducer( this.props.editor.state.jsonSrt, { index: srtBlock }, {
			leftPos: this.state.leftPos,
			start: this.state.start,
			end: this.state.end
		} );

		// UPDATE LEFT POSITION, START AND END OF SRT ON PARENT STATE
		this.props.editor.setState( prevState => ({
			jsonSrt: updatedJsonSrt
		}) );

		// CHECK IF WE NEED TO SET AS CURRENT SUBTITLE BLOCK (WE MAY HAVE DRAGGED ONTO INDICATOR)
		this.props.editor.checkCurrentSubtitleBlock( this.props.editor.video.currentTime );
	}


	// =============================================================================================
	dragDifference( e ) {

		this.end = 0;
		if ( e.pageX ) this.end = e.pageX;

		if ( this.prevX && e.pageX < this.prevX ) {
			if ( this.direction && this.direction === 'right' ) this.start = e.pageX;
			this.direction = 'left';
		} else {
			if ( this.direction && this.direction === 'left' ) this.start = e.pageX;
			this.direction = 'right';
		}

		return this.end - this.start;
	}


	// =============================================================================================
	adjustBlock( e, target ) {
		e.stopPropagation();

		let $this = this;

		if ( e.type === 'mousedown' ) this.startDragging( e, target );

		else if ( e.type === 'mouseup' ) this.stopDragging( e );

		// HANDLE DRAG
		if ( this.state.dragging ) {

			window.requestAnimationFrame( function() {

				if ( !$this.state.dragging ) return;

				let diff = $this.dragDifference( e ),
					start, end, leftPos, width;

				// IF DRAGGING THE MIDDLE › JUST
				if ( $this.state.dragTarget === 'middle' ) {

					start = $this.getTimeInPosition( $this.state.leftPos + diff );
					end = $this.getTimeInPosition( $this.state.leftPos + $this.state.width + diff );
					leftPos = $this.state.leftPos + diff;

				} else if ( $this.state.dragTarget === 'left' ) {

					start = $this.getTimeInPosition( $this.state.leftPos + diff );
					width = $this.state.width - diff;
					end = $this.state.end;
					leftPos = $this.state.leftPos + diff;

				} else if ( $this.state.dragTarget === 'right' ) {

					start = $this.state.start;
					width = $this.state.width + diff;
					end = $this.getTimeInPosition( $this.state.leftPos + width );
					leftPos = $this.state.leftPos;
				}

				// PREVENT THEM FROM RESIZING A BLOCK TO BE LESS THAN ONE SECOND
				if ( end - start > 1 && start > $this.state.minStart && end < $this.state.maxEnd ) {

					let state = {
						leftPos: leftPos,
						start: start,
						end: end
					};

					if ( typeof width !== 'undefined' ) state.width = width;

					$this.setState( prevState => ( state ) );
				}

				// UPDATE START SO WE DONT ACCUMULATE SPEED
				$this.start = e.pageX;

				$this.prevX = e.pageX;
			});
		}
	}


	// =============================================================================================
	getTimeInPosition( position, windowSecondValue ) {

		// IF NOT PASSED A windowSecondValue › EACH WINDOW WIDTH IS WORTH 10 SECONDS
		// NOTE: USED FOR JUMP TRACK RIGHT NOW
		windowSecondValue = windowSecondValue || 10;

		let trackWidth = Math.round( this.props.editor.video.duration / windowSecondValue * window.innerWidth ),
			duration = this.props.editor.video.duration;

		return duration / ( 100 / ( position / trackWidth * 100 ) );
	}
}

export default SubtitleBlock;


// WEBPACK FOOTER //
// ./src/scenes/Editor/subtitle-block.js